import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ["'Nunito Sans'", "'Roboto'", 'sans-serif'].join(', '),
  },
  palette: {
    primary: {
      main: '#326ac2',
    },
    secondary: {
      main: '#2ac682',
    },
    error: {
      main: '#A32828',
    },
  },
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: '#cfcfcf',
        },
        bar: {
          borderRadius: '8px',
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(15, 21, 33, 0.8)',
          variants: [
            {
              props: ({ ownerState }) => !!ownerState?.invisible,
              style: { backgroundColor: 'transparent' },
            },
          ],
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: (props) => props.className !== 'default',
              style: {
                border: '1px solid #dde0e7',
                borderRadius: 8,
              },
            },
          ],
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: (props) => props.className !== 'default',
              style: {
                '.MuiTableHead-root': {
                  backgroundColor: '#f6f8fc',
                  '& th': {
                    fontWeight: 700,
                    border: 'none',
                  },
                },
                '.MuiTableRow-root': {
                  border: 'none',
                  '& td': {
                    border: 'none',
                  },
                },
                '.MuiTableBody-root': {
                  '& tr': {
                    borderTop: '1px solid #dde0e7',
                  },
                },
              },
            },
            {
              props: (props) => props.className === 'default',
              style: {
                borderColor: '#dde0e7',
              },
            },
          ],
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export const premiumTheme = createTheme({
  typography: {
    fontFamily: ["'Nunito Sans'", "'Roboto'", 'sans-serif'].join(', '),
  },
  palette: {
    primary: {
      main: '#6236BD',
    },
  },
});

export default theme;
